// ── React Query hooks for graph data ──

import { useQuery } from "@tanstack/react-query";
import { graphApi } from "../api/graphApi";

export function useSites() {
  return useQuery({
    queryKey: ["sites"],
    queryFn: graphApi.getSites,
    staleTime: 5 * 60_000,
  });
}

export function useCampaigns(siteId: string | null) {
  return useQuery({
    queryKey: ["campaigns", siteId],
    queryFn: () => graphApi.getCampaigns(siteId!),
    enabled: !!siteId,
    staleTime: 5 * 60_000,
  });
}

export function useAreas(campaignId: string | null) {
  return useQuery({
    queryKey: ["areas", campaignId],
    queryFn: () => graphApi.getAreas(campaignId!),
    enabled: !!campaignId,
    staleTime: 5 * 60_000,
  });
}

export function useInspections(
  campaignId: string | null,
  areaName: string | null,
) {
  return useQuery({
    queryKey: ["inspections", campaignId, areaName],
    queryFn: () => graphApi.getInspections(campaignId!, areaName!),
    enabled: !!campaignId && !!areaName,
    staleTime: 2 * 60_000,
  });
}

export function usePhotos(recordId: string | null) {
  return useQuery({
    queryKey: ["photos", recordId],
    queryFn: () => graphApi.getPhotos(recordId!),
    enabled: !!recordId,
    staleTime: 10 * 60_000,
  });
}

export function useTrend(siteId: string | null) {
  return useQuery({
    queryKey: ["trend", siteId],
    queryFn: () => graphApi.getTrend(siteId!),
    enabled: !!siteId,
    staleTime: 5 * 60_000,
  });
}

export function useGeoCells(campaignId: string | null) {
  return useQuery({
    queryKey: ["geoCells", campaignId],
    queryFn: () => graphApi.getGeoCells(campaignId!),
    enabled: !!campaignId,
    staleTime: 5 * 60_000,
  });
}

export function useDeteriorating(campaignId: string | null) {
  return useQuery({
    queryKey: ["deteriorating", campaignId],
    queryFn: () => graphApi.getDeteriorating(campaignId!),
    enabled: !!campaignId,
    staleTime: 5 * 60_000,
  });
}

export function useInspectionDetail(inspectionId: string | null) {
  return useQuery({
    queryKey: ["inspectionDetail", inspectionId],
    queryFn: () => graphApi.getInspection(inspectionId!),
    enabled: !!inspectionId,
    staleTime: 5 * 60_000,
  });
}

export function useAreaStats(
  campaignId: string | null,
  areaName: string | null,
) {
  return useQuery({
    queryKey: ["areaStats", campaignId, areaName],
    queryFn: () => graphApi.getAreaStats(campaignId!, areaName!),
    enabled: !!campaignId && !!areaName,
    staleTime: 5 * 60_000,
  });
}

export function useFullGraph(siteId: string | null) {
  return useQuery({
    queryKey: ["fullGraph", siteId],
    queryFn: () => graphApi.getFullGraph(siteId!),
    enabled: !!siteId,
    staleTime: 10 * 60_000,
  });
}
